(function(){
    'use strict'

    angular.module('app.core')
    .factory('UserInfoService', UserInfoService);

    function UserInfoService(){

        var userInfo = {
            userId: '',
            userName: '',
            email: '',
            userDisplayName: '',
            token: null,
            refreshToken: null,
            tokenExpiresIn: 0,
            isAuthenticated: false,
            permisos: null,
            companiaId: null,
            companiaNombre: '',
            crearDocumentoValoresPorDefecto: null,
            grupoId: 0
        };

        var atletaSeleccionado = null;

        var opciones = {
            USUARIOS_ORGANIZADOR: 5,
            EVENTOS: 10,
            EVENTOS_LEVEL_2: 11,
            INSCRIPCIONES: 20,
            INSCRIPCIONES_LEVEL_2: 21,
            CUPONES: 40,
            CUPONES_LEVEL_2: 41,
            CATEGORIAS: 50,
            CATEGORIAS_LEVEL_2: 51,
            AGREGAR_TIEMPOS: 60,
            ASIGNAR_NUMEROS: 70,
            PAQUETES: 90
        };

        var searchKeys = [
            'Documentos_Aceptados_Search_Criteria',
            'Documentos_Rechazados_Search_Criteria',
            'Documentos_Procesar_Search_Criteria'
        ];

        var api = {
            userInfo: userInfo,
            opciones: opciones,
            setUser: setUser,
            setRefreshTokenInfo: setRefreshTokenInfo,
            getToken: getToken,
            setToken: setToken,
            getRefreshToken: getRefreshToken,
            logoutUser:logoutUser,
            getPermisos: getPermisos,
            getPermisosEventos: getPermisosEventos,
            getPermisosCupones: getPermisosCupones,
            getPermisosCategorias: getPermisosCategorias,
            getPermisosPaquetes: getPermisosPaquetes,
            getPermisosInscripciones: getPermisosInscripciones,
            getPermisosAgregarTiempos: getPermisosAgregarTiempos,
            getPermisosAsignarNumeros: getPermisosAsignarNumeros,
            getPermisosUsuarioOrganizador: getPermisosUsuarioOrganizador,
            saveDataOnSessionStorage: saveDataOnSessionStorage,
            getDataFromSessionStorage: getDataFromSessionStorage,
            deleteDataFromSessionStorage: deleteDataFromSessionStorage,
            searchKeys: searchKeys,
            removeSearchCriterias: removeSearchCriterias,
            eliminarBloqueosUsuario: true,
            getEmail: getEmail,
            getGrupo: getGrupo,
            getFullUser: getFullUser,
            esOrganizador: esOrganizador,
            getCrearDocumentoValoresPorDefecto: getCrearDocumentoValoresPorDefecto,
            setAtleta: setAtleta,
            getAtleta: getAtleta
        };

        getUserInfoFromSessionStorage();

        return api;

        function getToken(){
            return api.userInfo.token;
        }

        function getRefreshToken(){
            return api.userInfo.refreshToken;
        }

        function getEmail(){
            return api.userInfo.email;
        }

        function getGrupo(){
            return api.userInfo.grupoId;
        }

        function getFullUser(){
            return api.userInfo.fullUser;
        }

        function esOrganizador(){
            return api.userInfo.organizadorId !== undefined;
        }

        function getPermisos(permisoId){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === permisoId;
            });
        }

        function getPermisosEventos(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.EVENTOS_LEVEL_2;
            });
        }

        function getPermisosCupones(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.CUPONES_LEVEL_2;
            });
        }

        function getPermisosCategorias(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.CATEGORIAS_LEVEL_2;
            });
        }

        function getPermisosPaquetes(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.PAQUETES;
            });
        }

        function getPermisosInscripciones(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.INSCRIPCIONES_LEVEL_2;
            });
        }

        function getPermisosAgregarTiempos(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.AGREGAR_TIEMPOS;
            });
        }

        function getPermisosAsignarNumeros(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.ASIGNAR_NUMEROS;
            });
        }

        function getPermisosUsuarioOrganizador(){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === opciones.USUARIOS_ORGANIZADOR;
            });
        }

        function getCrearDocumentoValoresPorDefecto(){
            return api.userInfo.crearDocumentoValoresPorDefecto;
        }

        function setToken(token){
            api.userInfo.token = token;
        }

        function setUser(user, tokenInfo, loginInfo){
            api.userInfo.userId = user.id;
            api.userInfo.userName = user.userName;
            api.userInfo.isAuthenticated = user.isAuthenticated;
            api.userInfo.token = tokenInfo.access_token;
            api.userInfo.refreshToken = tokenInfo.refresh_token;
            api.userInfo.tokenExpiresIn = tokenInfo.expires_in;
            api.userInfo.userDisplayName = loginInfo.usuario.nombre;
            api.userInfo.permisos = loginInfo.permisos;
            api.userInfo.email = loginInfo.usuario.email;
            api.userInfo.grupoId = loginInfo.usuario.grupoId;
            api.userInfo.organizadorId = loginInfo.usuario.organizadorId
            api.userInfo.fullUser = loginInfo.usuario;
            api.userInfo.crearDocumentoValoresPorDefecto = loginInfo.crearDocumentoValoresPorDefecto;
            saveUserInfoOnSessionStorage();
            removeSearchCriterias();
        }

        function setRefreshTokenInfo(tokenInfo){
            api.userInfo.token = tokenInfo.access_token;
            api.userInfo.refreshToken = tokenInfo.refresh_token;
            api.userInfo.tokenExpiresIn = tokenInfo.expires_in;
            saveUserInfoOnSessionStorage();
        }

        function saveUserInfoOnSessionStorage(){
            sessionStorage.setItem('userInfo', JSON.stringify(api.userInfo));
        }

        function getUserInfoFromSessionStorage(){
            var info = sessionStorage.getItem('userInfo');
            if(info){
                api.userInfo = JSON.parse(info);
            }
        }

        function saveDataOnSessionStorage(key, value){
            sessionStorage.setItem(key, JSON.stringify(value));
        }

        function getDataFromSessionStorage(key){
            var data = sessionStorage.getItem(key);
            return JSON.parse(data);
        }

        function deleteUserInfoOnSessionStorage(){
            sessionStorage.removeItem('userInfo');
        }

        function deleteDataFromSessionStorage(key){
            sessionStorage.removeItem(key);
        }

        function logoutUser(){
            api.userInfo.isAuthenticated = false;
            api.userInfo.token = null;
            api.userInfo.companiaId = null;
            api.userInfo.companiaNombre = '';
            api.userInfo.permisos = null;
            api.userInfo.grupoId = 0;
            deleteUserInfoOnSessionStorage();
            removeSearchCriterias();
        }

        function removeSearchCriterias(){
            searchKeys.forEach(function(item){
                deleteDataFromSessionStorage(item);
            });
        };

        function setAtleta(atleta){
            atletaSeleccionado = atleta;
        }

        function getAtleta(){
            return atletaSeleccionado;
        }

    };


})();